// extracted by mini-css-extract-plugin
export default {"recipeList":"G67980e","recipeListText":"Ga0032e","item":"G3790b9"};